import React, { useState, useContext, useEffect } from 'react';
import MainContext from '../../../../store/MainContext';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FullCard from '../../../../components/Card/FullCard';
import API from '../../../../api/axios';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { FormHelperText } from '@material-ui/core';
import './setting.css';
import Previews from 'components/UploadDocument/DropZone';
import useTitle from 'hooks/useTitle';

function PublicSettings(props) {
  useTitle('تنظیمات عمومی');
  const main = useContext(MainContext);
  const { appName, appLogo } = main.state.Public;
  const [tempTitle, setTempTitle] = useState(appName);
  const [tempLogo, setTempLogo] = useState(null);
  const [submiting, setSubmiting] = useState(false);
  const [rules, setRules] = useState('');
  const [preview, setPreview] = useState(null);

  const handleChangeTitle = (e) => {
    setTempTitle(e.target.value);
  };

  const handleSelectFile = (e = '') => {
    const file = e;
    setTempLogo(file === '' ? undefined : file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSubmiting(true);
      let data = new FormData();
      data.set('appName', tempTitle);
      if (tempLogo !== undefined) {
        data.set('appLogo', tempLogo);
      }
      data.set('rules', rules);
      const response = await API.post(
        `/api/v1/admin/generalparam/public`,
        data,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      );
      const { appLogo, appName } = response.data;
      !!response.data &&
        props.showMessage(1, '', '', 'تنظیمات با موفقیت بروز گردید.');
      main.dispatch({ type: 'PUBLIC', action: 'SET', payload: response.data });
    } catch (error) {
      console.error(error);
      props.showMessage(3, '', '', 'بروز خطا');
    }
    setSubmiting(false);
  };

  const getRules = async () => {
    try {
      const { data } = await API.get(`/api/v1/admin/generalParam`);
      data?.rules && setRules(data.rules);
    } catch (error) {
      props.showError(error);
    }
  };

  useEffect(() => {
    getRules();
    return () => URL.revokeObjectURL(preview);
  }, []);

  return (
    <FullCard
      title={props.config.name}
      category="تنظیمات عمومی بکار رفته در همه نرم افزارها"
    >
      <form onSubmit={handleSubmit} style={{ maxWidth: 500 }}>
        <Grid container direction="column" spacing={1} alignItems="stretch">
          <Grid item>
            <TextField
              value={tempTitle}
              onChange={handleChangeTitle}
              variant="outlined"
              fullWidth
              label="نام نرم افزار"
            />
          </Grid>
          <Grid item>
            <Previews
              title={'انتخاب فایل لوگو'}
              getFile={(e) => handleSelectFile(e)}
              defaultFile={appLogo}
            />
          </Grid>

          <Grid item>
            <div className="editor">
              <ReactQuill
                scrollingContainer={'.editor'}
                bounds={'.editor'}
                theme="snow"
                value={rules}
                placeholder="قوانین و مقررات"
                onChange={setRules}
              />
            </div>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="secondary"
              size="large"
              fullWidth
              onClick={handleSubmit}
              disabled={submiting}
              type={'submit'}
            >
              ذخیره
            </Button>
          </Grid>
        </Grid>
      </form>
    </FullCard>
  );
}
export default PublicSettings;
